/* eslint-disable @typescript-eslint/no-non-null-assertion */
/* eslint-disable no-unused-expressions */
import { KeyboardEvent, useCallback, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { useHistory } from "react-router-dom";
import * as MUI from "@mui/material";
import * as MUIcons from "@mui/icons-material";

import { celularStoreImei } from "../../../hooks/store";
import { useAuth } from "../../../hooks/auth";
import { IMEIScanner, ResultadoConsultaCelular } from "../../../components";

import { LayoutConsultaCelular } from "./LayoutConsultaCelular";

type InputProps = {
  imei: string;
};

export const ConsultaCelular: React.FC = () => {
  const { control, handleSubmit, setValue } = useForm<InputProps>({
    defaultValues: {
      imei: "",
    },
  });
  const history = useHistory();
  const { user } = useAuth();

  // ADICIONAR estas linhas após os hooks existentes:
  const [showScanner, setShowScanner] = useState(false);

  const { url } = user!.sistemas.filter((s) => {
    return s.id_sistema === 1 ? s.url : false;
  })[0];

  const {
    consultaCelularImei,
    mensagemCelular,
    limparConsultaCelularImei,
    resultadoCelularImei,
  } = celularStoreImei((state) => state.celular);

  const { loading } = celularStoreImei((state) => state.global);

  const PesquisaImeiCelular = (data: InputProps) => {
    consultaCelularImei(url, data.imei);
  };

  const keyBoardClick = useCallback((e: KeyboardEvent<HTMLInputElement>) => {
    e.key === "Enter";
  }, []);

  const handleRedirectInfo = () => {
    return history.push("/alerta/consulta-celular/ficha-celular", {
      dados: resultadoCelularImei,
    });
  };

  const handleIMEIDetected = (imei: string) => {
    setValue("imei", imei);
    setShowScanner(false);
  };

  return (
    <LayoutConsultaCelular>
      <MUI.Grid
        component="form"
        alignItems="center"
        width={["100%", "100%", "100%", "80%", "60%"]}
        container
        spacing={1}
        onSubmit={handleSubmit(PesquisaImeiCelular)}
      >
        <MUI.Grid item xs={12} md={4} sm={4}>
          <Controller
            name="imei"
            control={control}
            render={({ field: { value, onChange } }) => (
              <MUI.TextField
                label="Informe o IMEI"
                value={value.replace(/\D/g, "")}
                onChange={onChange}
                onKeyPress={keyBoardClick}
                fullWidth
                size="small"
                disabled={loading}
                InputProps={{
                  endAdornment: (
                    <MUI.InputAdornment position="end">
                      <MUI.IconButton
                        aria-label="scan barcode"
                        onClick={() => setShowScanner(true)}
                        edge="end"
                      >
                        <MUIcons.QrCodeScanner />
                      </MUI.IconButton>
                    </MUI.InputAdornment>
                  ),
                }}
              />
            )}
          />
        </MUI.Grid>

        <MUI.Grid item xs={12} md={3} sm={3}>
          <MUI.Button
            fullWidth
            variant="contained"
            color="primary"
            type="submit"
            disabled={loading}
            startIcon={<MUIcons.Search />}
          >
            <MUI.Typography
              variant="button"
              whiteSpace="nowrap"
              textOverflow="ellipsis"
              overflow="hidden"
            >
              Consultar
            </MUI.Typography>
          </MUI.Button>
        </MUI.Grid>
        <MUI.Grid item xs={12} md={3} sm={3}>
          <MUI.Button
            fullWidth
            variant="outlined"
            color="secondary"
            onClick={limparConsultaCelularImei}
            disabled={loading}
            startIcon={<MUIcons.Clear />}
          >
            <MUI.Typography
              variant="button"
              whiteSpace="nowrap"
              textOverflow="ellipsis"
              overflow="hidden"
            >
              Limpar resultado
            </MUI.Typography>
          </MUI.Button>
        </MUI.Grid>
      </MUI.Grid>

      <MUI.Stack>
        {resultadoCelularImei || mensagemCelular ? (
          <MUI.Typography variant="h6">Resultado da consulta:</MUI.Typography>
        ) : (
          false
        )}

        {!loading ? (
          (resultadoCelularImei && (
            <ResultadoConsultaCelular
              situacao={
                resultadoCelularImei?.APARELHO_INFOPOL
                  ? resultadoCelularImei.APARELHO_INFOPOL.SITUACAO
                  : resultadoCelularImei?.APARELHO_ALERTA?.SITUACAO
              }
              imei={
                resultadoCelularImei?.APARELHO_INFOPOL &&
                resultadoCelularImei?.APARELHO_INFOPOL
                  ? resultadoCelularImei.APARELHO_INFOPOL.IMEIS[0]
                  : resultadoCelularImei?.APARELHO_ALERTA?.IMEI
              }
              marca={
                resultadoCelularImei?.APARELHO_INFOPOL
                  ? resultadoCelularImei.APARELHO_INFOPOL.MARCA
                  : resultadoCelularImei?.APARELHO_ALERTA?.MARCA
              }
              modelo={
                resultadoCelularImei?.APARELHO_INFOPOL
                  ? resultadoCelularImei.APARELHO_INFOPOL.MODELO
                  : resultadoCelularImei?.APARELHO_ALERTA?.MODELO
              }
              onClick={() => handleRedirectInfo()}
            />
          )) || <MUI.Typography variant="h6">{mensagemCelular}</MUI.Typography>
        ) : (
          <MUI.LinearProgress />
        )}
      </MUI.Stack>

      {/* Scanner IMEI */}
      <IMEIScanner
        open={showScanner}
        onClose={() => setShowScanner(false)}
        onDetected={handleIMEIDetected}
        title="Scanner de IMEI"
      />
    </LayoutConsultaCelular>
  );
};
